var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueThinArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35392 0.645917C7.40048 0.692363 7.43742 0.747539 7.46263 0.808284C7.48784 0.869029 7.50081 0.93415 7.50081 0.999917C7.50081 1.06568 7.48784 1.13081 7.46263 1.19155C7.43742 1.2523 7.40048 1.30747 7.35392 1.35392L1.70692 6.99992L7.35392 12.6459C7.4478 12.7398 7.50055 12.8671 7.50055 12.9999C7.50055 13.1327 7.4478 13.26 7.35392 13.3539C7.26003 13.4478 7.13269 13.5005 6.99992 13.5005C6.86714 13.5005 6.7398 13.4478 6.64592 13.3539L0.645917 7.35392C0.599354 7.30747 0.562411 7.2523 0.537204 7.19155C0.511998 7.13081 0.499023 7.06568 0.499023 6.99992C0.499023 6.93415 0.511998 6.86903 0.537204 6.80828C0.562411 6.74754 0.599354 6.69236 0.645917 6.64592L6.64592 0.645917C6.69236 0.599354 6.74754 0.562411 6.80828 0.537205C6.86903 0.511998 6.93415 0.499023 6.99992 0.499023C7.06568 0.499023 7.13081 0.511998 7.19155 0.537205C7.2523 0.562411 7.30747 0.599354 7.35392 0.645917Z",
    fill: "#071C47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueThinArrow);
export default __webpack_public_path__ + "static/media/blueThinArrow.e2c83ccdf4d808bb2bfe39a4f49a2f61.svg";
export { ForwardRef as ReactComponent };